<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i5DImS/tc-custom/9781466887312.jpg?1731166637582" alt="This image is the cover for the book Kind Folk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kind Folk
      </h1>
      <p class="bookDescription body article font2">
        <p>In Ramsey Campbell's <i>The Kind Folk, </i>fairies are real . . . and they're coming for you. <br/><br/>Luke Arnold is a successful stage comedian who, with his partner Sophie Drew, is about to have their first child. Their life seems ideal and Luke feels that true happiness is finally within his grasp. <br/><br/>This wasn't always the case. Growing up in a loving but dysfunctional family, Luke was a lonely little boy who never felt that he belonged. While his parents adored him, the whole family knew that due to a mix-up at the hospital, Luke wasn't their biological child. His parents did the best they could to make the lad feel special. But it was his beloved uncle Terence who Luke felt most close to, a man who enchanted (and frightened) the lad with tales of the "Other"--eldritch beings, hedge folks, and other fables of Celtic myth. <br/><br/>When Terence dies in a freak accident, Luke suddenly begins to learn how little he really knew his uncle. How serious was Terence about the magic in his tales? Why did he travel so widely by himself after Luke was born, and what was he looking for? Soon Luke will have to confront forces that may be older than the world in order to save his unborn child.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ramsey Campbell
      </h2>
      
      <p class="authorDescription body article">Ramsey Campbell is described by <I>The</I><I>Oxford Companion to English Literature </I>as &ldquo;Britain&rsquo;s most respected living horror writer,&rdquo; and the <I>Washington Post </I>names his work as &ldquo;one of the monumental accomplishments of modern popular fiction.&rdquo; The two volumes of <I>Phantasmagorical Stories</I> offer a sixty-year retrospective of his short fiction. <I>The Village Killings </I>collects his novellas, and <I>Ramsey&rsquo;s Rambles </I>his film reviews. Campbell&rsquo;s latest novel is <I>The Lonely Lands</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36f26058